import { useCallback } from 'react';
import { API_BASE_URL, getTenantId } from '../config/api';

export const useApi = () => {
  const apiCall = useCallback(async (url, options = {}) => {
    const token = localStorage.getItem('token');

    // Récupérer le tenant_id de manière centralisée (pas de fallback hardcodé)
    const tenantId = getTenantId();

    // Ne pas définir Content-Type pour FormData
    const isFormData = options.body instanceof FormData;
    const headers = {
      ...(tenantId && { 'x-tenant-id': tenantId }),
      ...options.headers
    };
    
    // Ajouter le token seulement s'il existe
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    
    const response = await fetch(fullUrl, {
      headers,
      cache: 'no-cache', // Force pas de cache
      ...options
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
    }

    return response.json();
  }, []);

  return { apiCall, API_BASE_URL };
};